module.exports = __webpack_public_path__ + "static/media/details-23-image-1.f5c43cfc.jpg";